export class UrlJsonConfig {
  urlConfig: any = {
    demo: {
      BASE_URL: 'https://demo-klearclaims-api.azurewebsites.net/api/',
      JOB_URL: 'https://demo-klearjobs-api.azurewebsites.net/api/',
      TOKEN_API_URL: 'https://demo-klearai-auth.azurewebsites.net/api',
      AUTH_URL: 'https://demo-klearai.azurewebsites.net',
      DOC_URL: 'https://demo-klearai-util.azurewebsites.net/api/',
      EXTENDED_PERIOD: 120,
      TIMEOUT_PERIOD: 10800,
      REFRESH_TOKEN_TIME: 300,
      CHECK_REFRESH_TOKEN_TIME: 90,
      PRODUCT_ID: '9',
      PARAMS_BY_CLIENT_MAP: {
        adminsure: {
          blobSassUrl: 'https://klearai.blob.core.windows.net',
          containerName: 'demo',
          token:
            'sp=racwdlme&st=2022-11-26T01:32:06Z&se=2024-11-26T09:32:06Z&spr=https&sv=2021-06-08&sr=c&sig=ixe2yNMVi6RzzGkNyM%2BEfzJZVsPozB5wURJM04vu8Ic%3D',
          isFroiSroiEnabled: true,
        },
        ics: {
          blobSassUrl: 'https://klearai.blob.core.windows.net',
          containerName: 'demo',
          token:
            'sp=racwdlme&st=2022-11-26T01:32:06Z&se=2024-11-26T09:32:06Z&spr=https&sv=2021-06-08&sr=c&sig=ixe2yNMVi6RzzGkNyM%2BEfzJZVsPozB5wURJM04vu8Ic%3D',
          isFroiSroiEnabled: true,
        },
        solace: {
          blobSassUrl: 'https://klearai.blob.core.windows.net',
          containerName: 'demo',
          token:
            'sp=racwdlme&st=2022-11-26T01:32:06Z&se=2024-11-26T09:32:06Z&spr=https&sv=2021-06-08&sr=c&sig=ixe2yNMVi6RzzGkNyM%2BEfzJZVsPozB5wURJM04vu8Ic%3D',
          isFroiSroiEnabled: true,
        },
      },
    },
    kleardemo: {
      BASE_URL: 'https://kleardemo-klearclaims-api.azurewebsites.net/api/',
      JOB_URL: 'https://kleardemo-klearjobs-api.azurewebsites.net/api/',
      TOKEN_API_URL: 'https://kleardemo-klearai-auth.azurewebsites.net/api',
      DOC_URL: 'https://kleardemo-klearai-util.azurewebsites.net/api/',
      CLAIMS_URL: 'https://kleardemo-claims.klearai.com',
      UR_URL: 'https://kleardemo-ur.klearai.com',
      UM_URL: 'https://kleardemo-usermanagement.klearai.com',
      RMIS_URL: 'https://kleardemo-rmis.klearai.com',
      INTAKE_URL: 'https://kleardemo-intake.klearai.com',
      AUDIT_URL: 'https://kleardemo-audit.klearai.com',
      AUTH_URL: 'https://kleardemo.klearai.com',
      EXTENDED_PERIOD: 120,
      TIMEOUT_PERIOD: 1800,
      REFRESH_TOKEN_TIME: 300,
      CHECK_REFRESH_TOKEN_TIME: 90,
      PRODUCT_ID: '9',
      LETTER_URL: 'https://api.office-integrator.com',
      PARAMS_BY_CLIENT_MAP: {
        demo: {
          blobSassUrl: 'https://klearai.blob.core.windows.net',
          containerName: 'demo',
          token:
            'sp=racwdlme&st=2022-11-26T01:32:06Z&se=2024-11-26T09:32:06Z&spr=https&sv=2021-06-08&sr=c&sig=ixe2yNMVi6RzzGkNyM%2BEfzJZVsPozB5wURJM04vu8Ic%3D',
          isFroiSroiEnabled: true,
        },
      },
    },
    demo1: {
      BASE_URL: 'https://demo1-klearclaims-api.azurewebsites.net/api/',
      JOB_URL: 'https://demo1-klearjobs-api.azurewebsites.net/api/',
      TOKEN_API_URL: 'https://demo1-klearai-auth.azurewebsites.net/api/',
      AUTH_URL: 'https://demo1-klearai.azurewebsites.net',
      DOC_URL: 'https://demo1-klearai-util.azurewebsites.net/api/',
      EXTENDED_PERIOD: 120,
      TIMEOUT_PERIOD: 10800,
      REFRESH_TOKEN_TIME: 300,
      CHECK_REFRESH_TOKEN_TIME: 90,
      PRODUCT_ID: '9',
      PARAMS_BY_CLIENT_MAP: {
        adminsure: {
          blobSassUrl: 'https://klearai.blob.core.windows.net',
          containerName: 'demo',
          token:
            'sp=racwdlme&st=2022-11-26T01:32:06Z&se=2024-11-26T09:32:06Z&spr=https&sv=2021-06-08&sr=c&sig=ixe2yNMVi6RzzGkNyM%2BEfzJZVsPozB5wURJM04vu8Ic%3D',
          isFroiSroiEnabled: true,
        },
        ics: {
          blobSassUrl: 'https://klearai.blob.core.windows.net',
          containerName: 'demo',
          token:
            'sp=racwdlme&st=2022-11-26T01:32:06Z&se=2024-11-26T09:32:06Z&spr=https&sv=2021-06-08&sr=c&sig=ixe2yNMVi6RzzGkNyM%2BEfzJZVsPozB5wURJM04vu8Ic%3D',
          isFroiSroiEnabled: true,
        },
        solace: {
          blobSassUrl: 'https://klearai.blob.core.windows.net',
          containerName: 'demo',
          token:
            'sp=racwdlme&st=2022-11-26T01:32:06Z&se=2024-11-26T09:32:06Z&spr=https&sv=2021-06-08&sr=c&sig=ixe2yNMVi6RzzGkNyM%2BEfzJZVsPozB5wURJM04vu8Ic%3D',
          isFroiSroiEnabled: true,
        },
      },
		},
    eco: {
      BASE_URL: "https://deveco-klearclaims-api.azurewebsites.net/api/",
      JOB_URL: "https://deveco-klearjobs-api.azurewebsites.net/api/",
      TOKEN_API_URL: "https://deveco-klearai-auth.azurewebsites.net/api",
      DOC_URL: "https://deveco-klearai-util.azurewebsites.net/api/",
      CLAIMS_URL: "https://deveco-claims.klearai.com",
      UR_URL: "https://deveco-ur.klearai.com",
      UM_URL: "https://deveco-usermanagement.klearai.com",
      RMIS_URL: "https://deveco-rmis.klearai.com",
      INTAKE_URL: "https://deveco-intake.klearai.com",
      AUDIT_URL: "https://deveco-audit.klearai.com",
      AUTH_URL: "https://deveco.klearai.com",
			EXTENDED_PERIOD: 120,
			TIMEOUT_PERIOD: 1800,
			REFRESH_TOKEN_TIME: 300,
			CHECK_REFRESH_TOKEN_TIME: 90,
      PRODUCT_ID: "1",
      LETTER_URL: "https://api.office-integrator.com",
      PARAMS_BY_CLIENT_MAP: {
        eco: {
          blobSassUrl: "https://klearai.blob.core.windows.net",
          containerName: "dev",
          token: "sp=racwle&st=2022-10-29T16:48:44Z&se=2024-10-30T00:48:44Z&spr=https&sv=2021-06-08&sr=c&sig=BdCezwLyvULAghlA3xrv4hVtrVbTQbe9jtpUpQCThuI%3D",
          isFroiSroiEnabled: true,
        },
        adminsure: {
          blobSassUrl: "https://klearai.blob.core.windows.net",
          containerName: "dev",
          token: "sp=racwle&st=2022-10-29T16:48:44Z&se=2024-10-30T00:48:44Z&spr=https&sv=2021-06-08&sr=c&sig=BdCezwLyvULAghlA3xrv4hVtrVbTQbe9jtpUpQCThuI%3D",
          isFroiSroiEnabled: true,
        },
        ics: {
          blobSassUrl: "https://klearai.blob.core.windows.net",
          containerName: "dev",
          token: "sp=racwle&st=2022-10-29T16:48:44Z&se=2024-10-30T00:48:44Z&spr=https&sv=2021-06-08&sr=c&sig=BdCezwLyvULAghlA3xrv4hVtrVbTQbe9jtpUpQCThuI%3D",
          isFroiSroiEnabled: true,
        },
        solace: {
          blobSassUrl: "https://klearai.blob.core.windows.net",
          containerName: "dev",
          token: "sp=racwle&st=2022-10-29T16:48:44Z&se=2024-10-30T00:48:44Z&spr=https&sv=2021-06-08&sr=c&sig=BdCezwLyvULAghlA3xrv4hVtrVbTQbe9jtpUpQCThuI%3D",
          isFroiSroiEnabled: true,
        },
      },
    },
		dev: {
      BASE_URL: "https://deveco-klearclaims-api.azurewebsites.net/api/",
      JOB_URL: "https://deveco-klearjobs-api.azurewebsites.net/api/",
      TOKEN_API_URL: "https://deveco-klearai-auth.azurewebsites.net/api",
      DOC_URL: "https://deveco-klearai-util.azurewebsites.net/api/",
      CLAIMS_URL: "https://deveco-claims.klearai.com",
      UR_URL: "https://deveco-ur.klearai.com",
      UM_URL: "https://deveco-usermanagement.klearai.com",
      RMIS_URL: "https://deveco-rmis.klearai.com",
      INTAKE_URL: "https://deveco-intake.klearai.com",
      AUDIT_URL: "https://deveco-audit.klearai.com",
      AUTH_URL: "https://deveco.klearai.com",
			EXTENDED_PERIOD: 120,
			TIMEOUT_PERIOD: 1800,
			REFRESH_TOKEN_TIME: 300,
			CHECK_REFRESH_TOKEN_TIME: 90,
      PRODUCT_ID: "1",
      LETTER_URL: "https://api.office-integrator.com",
      PARAMS_BY_CLIENT_MAP: {
        eco: {
          blobSassUrl: 'https://klearai.blob.core.windows.net',
          containerName: 'dev',
          token:
            'sp=racwle&st=2022-10-29T16:48:44Z&se=2024-10-30T00:48:44Z&spr=https&sv=2021-06-08&sr=c&sig=BdCezwLyvULAghlA3xrv4hVtrVbTQbe9jtpUpQCThuI%3D',
          isFroiSroiEnabled: true,
        },
        adminsure: {
          blobSassUrl: 'https://klearai.blob.core.windows.net',
          containerName: 'dev',
          token:
            'sp=racwle&st=2022-10-29T16:48:44Z&se=2024-10-30T00:48:44Z&spr=https&sv=2021-06-08&sr=c&sig=BdCezwLyvULAghlA3xrv4hVtrVbTQbe9jtpUpQCThuI%3D',
          isFroiSroiEnabled: true,
        },
        ics: {
          blobSassUrl: 'https://klearai.blob.core.windows.net',
          containerName: 'dev',
          token:
            'sp=racwle&st=2022-10-29T16:48:44Z&se=2024-10-30T00:48:44Z&spr=https&sv=2021-06-08&sr=c&sig=BdCezwLyvULAghlA3xrv4hVtrVbTQbe9jtpUpQCThuI%3D',
          isFroiSroiEnabled: true,
        },
        solace: {
          blobSassUrl: 'https://klearai.blob.core.windows.net',
          containerName: 'dev',
          token:
            'sp=racwle&st=2022-10-29T16:48:44Z&se=2024-10-30T00:48:44Z&spr=https&sv=2021-06-08&sr=c&sig=BdCezwLyvULAghlA3xrv4hVtrVbTQbe9jtpUpQCThuI%3D',
          isFroiSroiEnabled: true,
        },
      },
    },
    dev1: {
      BASE_URL: 'https://dev1-klearclaims-api.azurewebsites.net/api/',
      JOB_URL: 'https://dev1-klearjobs-api.azurewebsites.net/api/',
      TOKEN_API_URL: 'https://dev1-klearai-auth.azurewebsites.net/api/',
      AUTH_URL: 'https://dev1.klearai.com',
      DOC_URL: 'https://dev1-klearai-util.azurewebsites.net/api/',
      CLAIMS_URL: 'https://dev1-claims.klearai.com',
      UR_URL: 'https://dev1-ur.klearai.com',
      UM_URL: 'https://dev1-usermanagement.klearai.com',
      RMIS_URL: 'https://dev1-rmis.klearai.com',
      INTAKE_URL: 'https://dev1-intake.klearai.com',
      AUDIT_URL: 'https://dev1-audit.klearai.com',
      EXTENDED_PERIOD: 120,
      TIMEOUT_PERIOD: 1800,
      REFRESH_TOKEN_TIME: 300,
      CHECK_REFRESH_TOKEN_TIME: 90,
      PRODUCT_ID: '9',
      LETTER_URL: 'https://api.office-integrator.com',
      PARAMS_BY_CLIENT_MAP: {
        adminsure: {
          blobSassUrl: 'https://klearai.blob.core.windows.net',
          containerName: 'dev',
          token:
            'sp=racwle&st=2022-10-29T16:48:44Z&se=2024-10-30T00:48:44Z&spr=https&sv=2021-06-08&sr=c&sig=BdCezwLyvULAghlA3xrv4hVtrVbTQbe9jtpUpQCThuI%3D',
          isFroiSroiEnabled: true,
        },
        ics: {
          blobSassUrl: 'https://klearai.blob.core.windows.net',
          containerName: 'dev',
          token:
            'sp=racwle&st=2022-10-29T16:48:44Z&se=2024-10-30T00:48:44Z&spr=https&sv=2021-06-08&sr=c&sig=BdCezwLyvULAghlA3xrv4hVtrVbTQbe9jtpUpQCThuI%3D',
          isFroiSroiEnabled: true,
        },
        solace: {
          blobSassUrl: 'https://klearai.blob.core.windows.net',
          containerName: 'dev',
          token:
            'sp=racwle&st=2022-10-29T16:48:44Z&se=2024-10-30T00:48:44Z&spr=https&sv=2021-06-08&sr=c&sig=BdCezwLyvULAghlA3xrv4hVtrVbTQbe9jtpUpQCThuI%3D',
          isFroiSroiEnabled: true,
        },
      },
		},
		localhost: {
      BASE_URL: 'https://dev1-klearclaims-api.azurewebsites.net/api/',
      JOB_URL: 'https://dev1-klearjobs-api.azurewebsites.net/api/',
      TOKEN_API_URL: 'https://dev1-klearai-auth.azurewebsites.net/api/',
      AUTH_URL: 'http://localhost:4100',
      DOC_URL: 'https://dev1-klearai-util.azurewebsites.net/api/',
      CLAIMS_URL: 'https://dev1-claims.klearai.com',
      UR_URL: 'https://dev1-ur.klearai.com',
      UM_URL: 'http://localhost:4300',
      RMIS_URL: 'https://dev1-rmis.klearai.com',
      INTAKE_URL: 'http://localhost:4400',
      AUDIT_URL: 'http://localhost:4600',
      EXTENDED_PERIOD: 120,
      TIMEOUT_PERIOD: 1800,
      REFRESH_TOKEN_TIME: 300,
      CHECK_REFRESH_TOKEN_TIME: 90,
      PRODUCT_ID: '9',
      LETTER_URL: 'https://api.office-integrator.com',
      PARAMS_BY_CLIENT_MAP: {
        adminsure: {
          blobSassUrl: 'https://klearai.blob.core.windows.net',
          containerName: 'dev',
          token:
            'sp=racwle&st=2022-10-29T16:48:44Z&se=2024-10-30T00:48:44Z&spr=https&sv=2021-06-08&sr=c&sig=BdCezwLyvULAghlA3xrv4hVtrVbTQbe9jtpUpQCThuI%3D',
          isFroiSroiEnabled: true,
        },
        ics: {
          blobSassUrl: 'https://klearai.blob.core.windows.net',
          containerName: 'dev',
          token:
            'sp=racwle&st=2022-10-29T16:48:44Z&se=2024-10-30T00:48:44Z&spr=https&sv=2021-06-08&sr=c&sig=BdCezwLyvULAghlA3xrv4hVtrVbTQbe9jtpUpQCThuI%3D',
          isFroiSroiEnabled: true,
        },
        solace: {
          blobSassUrl: 'https://klearai.blob.core.windows.net',
          containerName: 'dev',
          token:
            'sp=racwle&st=2022-10-29T16:48:44Z&se=2024-10-30T00:48:44Z&spr=https&sv=2021-06-08&sr=c&sig=BdCezwLyvULAghlA3xrv4hVtrVbTQbe9jtpUpQCThuI%3D',
          isFroiSroiEnabled: true,
        },
      },
    },
    dev2: {
      BASE_URL: 'https://dev2-klearclaims-api.azurewebsites.net/api/',
      JOB_URL: 'https://dev2-klearjobs-api.azurewebsites.net/api/',
      TOKEN_API_URL: 'https://dev2-klearai-auth.azurewebsites.net/api/',
      AUTH_URL: 'https://dev2.klearai.com',
      DOC_URL: 'https://dev2-klearai-util.azurewebsites.net/api/',
      CLAIMS_URL: 'https://dev2-claims.klearai.com',
      UR_URL: 'https://dev2-ur.klearai.com',
      UM_URL: 'https://dev2-usermanagement.klearai.com',
      RMIS_URL: 'https://dev2-rmis.klearai.com',
      INTAKE_URL: 'https://dev2-intake.klearai.com',
      AUDIT_URL: 'https://dev2-audit.klearai.com',
      EXTENDED_PERIOD: 120,
      TIMEOUT_PERIOD: 1800,
      REFRESH_TOKEN_TIME: 300,
      CHECK_REFRESH_TOKEN_TIME: 90,
      PRODUCT_ID: '1',
      LETTER_URL: 'https://api.office-integrator.com',
      PARAMS_BY_CLIENT_MAP: {
        adminsure: {
          blobSassUrl: 'https://klearai.blob.core.windows.net',
          containerName: 'dev',
          token:
            'sp=racwle&st=2022-10-29T16:48:44Z&se=2024-10-30T00:48:44Z&spr=https&sv=2021-06-08&sr=c&sig=BdCezwLyvULAghlA3xrv4hVtrVbTQbe9jtpUpQCThuI%3D',
          isFroiSroiEnabled: true,
        },
        ics: {
          blobSassUrl: 'https://klearai.blob.core.windows.net',
          containerName: 'dev',
          token:
            'sp=racwle&st=2022-10-29T16:48:44Z&se=2024-10-30T00:48:44Z&spr=https&sv=2021-06-08&sr=c&sig=BdCezwLyvULAghlA3xrv4hVtrVbTQbe9jtpUpQCThuI%3D',
          isFroiSroiEnabled: true,
        },
        solace: {
          blobSassUrl: 'https://klearai.blob.core.windows.net',
          containerName: 'dev',
          token:
            'sp=racwle&st=2022-10-29T16:48:44Z&se=2024-10-30T00:48:44Z&spr=https&sv=2021-06-08&sr=c&sig=BdCezwLyvULAghlA3xrv4hVtrVbTQbe9jtpUpQCThuI%3D',
          isFroiSroiEnabled: true,
        },
      },
    },
    qa2: {
      BASE_URL: 'https://qa2-klearclaims-api.azurewebsites.net/api/',
      JOB_URL: 'https://qa2-klearjobs-api.azurewebsites.net/api/',
      TOKEN_API_URL: 'https://qa2-klearai-auth.azurewebsites.net/api/',
      AUTH_URL: 'https://qa2.klearai.com',
      DOC_URL: 'https://qa2-klearai-util.azurewebsites.net/api/',
      CLAIMS_URL: 'https://qa2-claims.klearai.com',
      UR_URL: 'https://qa2-ur.klearai.com',
      UM_URL: 'https://qa2-usermanagement.klearai.com',
      RMIS_URL: 'https://qa2-rmis.klearai.com',
      INTAKE_URL: 'https://qa2-intake.klearai.com',
      AUDIT_URL: 'https://qa2-audit.klearai.com',
      EXTENDED_PERIOD: 120,
      TIMEOUT_PERIOD: 1800,
      REFRESH_TOKEN_TIME: 300,
      CHECK_REFRESH_TOKEN_TIME: 90,
      PRODUCT_ID: '1',
      LETTER_URL: 'https://api.office-integrator.com',
      PARAMS_BY_CLIENT_MAP: {
        adminsure: {
          blobSassUrl: 'https://klearai.blob.core.windows.net',
          containerName: 'test',
          token:
            'sp=racwdlme&st=2022-11-23T15:14:35Z&se=2024-11-23T23:14:35Z&spr=https&sv=2021-06-08&sr=c&sig=yd7hKmhfxBvzM23mxEpNwAbIo8mdiVZVfwl4axmIIXU%3D',
          isFroiSroiEnabled: true,
        },
        ics: {
          blobSassUrl: 'https://klearai.blob.core.windows.net',
          containerName: 'test',
          token:
            'sp=racwdlme&st=2022-11-23T15:14:35Z&se=2024-11-23T23:14:35Z&spr=https&sv=2021-06-08&sr=c&sig=yd7hKmhfxBvzM23mxEpNwAbIo8mdiVZVfwl4axmIIXU%3D',
          isFroiSroiEnabled: true,
        },
        solace: {
          blobSassUrl: 'https://klearai.blob.core.windows.net',
          containerName: 'test',
          token:
            'sp=racwdlme&st=2022-11-23T15:14:35Z&se=2024-11-23T23:14:35Z&spr=https&sv=2021-06-08&sr=c&sig=yd7hKmhfxBvzM23mxEpNwAbIo8mdiVZVfwl4axmIIXU%3D',
          isFroiSroiEnabled: true,
        },
      },
    },
		prod: {
      BASE_URL: "https://prod-klearclaims-api.azurewebsites.net/api/",
      JOB_URL: "https://prod-klearjobs-api.azurewebsites.net/api/",
			TOKEN_API_URL: "https://prod-klearai-auth.azurewebsites.net/api/",
			AUTH_URL: "https://klearai.azurewebsites.net",
			DOC_URL: "https://prod-klearai-util.azurewebsites.net/api/",
			EXTENDED_PERIOD: 120,
			TIMEOUT_PERIOD: 10800,
			REFRESH_TOKEN_TIME: 300,
			CHECK_REFRESH_TOKEN_TIME: 90,
      PRODUCT_ID: "9",
      PARAMS_BY_CLIENT_MAP: {
        adminsure: {
          blobSassUrl: 'https://adminsureklearaiprod.blob.core.windows.net',
          containerName: 'prd',
          token:
            '?sp=racwlme&st=2023-07-30T20:05:39Z&se=2024-12-31T20:05:39Z&spr=https&sv=2022-11-02&sr=c&sig=RH4SktFSiBTfq%2B7WmIv%2BvDXHwDtrZZ8mj2JucPry2Tw%3D',
          isFroiSroiEnabled: true,
        },
        ics: {
          blobSassUrl: 'https://icsklearaiprd.blob.core.windows.net',
          containerName: 'prd',
          token:
            '?sv=2021-12-02&ss=b&srt=sco&sp=rwdlacyx&se=2026-01-01T02:51:07Z&st=2023-04-15T17:51:07Z&spr=https&sig=zk9KYvLgzk1VV3Dwg1azhOIJ4faRzbBoBe6PQ%2BdIqUA%3D',
          isFroiSroiEnabled: true,
        },
        solace: {
          blobSassUrl: 'https://solaceklearai.blob.core.windows.net',
          containerName: 'prod',
          token:
            '?sp=racwdlmp&st=2024-05-06T06:07:43Z&se=2030-12-31T15:07:43Z&spr=https&sv=2022-11-02&sr=c&sig=U1jfIlxyqVmyENBUoelvxqN1WO%2B5aMwF%2Fru4cIx%2BoqA%3D',
          isFroiSroiEnabled: true,
        },
        sia: {
          blobSassUrl: 'https://siaklearaiprod.blob.core.windows.net',
          containerName: 'prd',
          token:
            '?sp=racwdlmeop&st=2024-03-17T22:00:17Z&se=2031-01-01T07:00:17Z&spr=https&sv=2022-11-02&sr=c&sig=UWIY1MLt8bONzcYjtd3blqMlM8RzBLKZ6Y5EcLiAuME%',
          isFroiSroiEnabled: true,
        },
        sierrarisk: {
          blobSassUrl: 'https://sierrariskklearaiprod.blob.core.windows.net',
          containerName: 'prd',
          token:
            '?sp=racwdlmeop&st=2024-03-17T22:04:12Z&se=2031-01-01T07:04:12Z&spr=https&sv=2022-11-02&sr=c&sig=U1dE5nUB%2BFbl7QmmzIliLY8JPs2dbvozDKGMd25aHYA%3D',
          isFroiSroiEnabled: true,
        },
        nextinsurance: {
          blobSassUrl: 'https://nextinsuranceklearai.blob.core.windows.net',
          containerName: 'prod',
          token: '?sp=racwdlmep&st=2024-06-17T09:11:14Z&se=2030-01-01T18:11:14Z&sv=2022-11-02&sr=c&sig=4cnF4Upjjl0K596QJQq9A0hIFFdkhcM28tfDyJS1Fkc%3D',
          isFroiSroiEnabled: true,
        },
        gas: {
          blobSassUrl: 'https://gasprd.blob.core.windows.net',
          containerName: 'prod',
          token: 'sp=racwdlmeo&st=2024-08-25T07:14:21Z&se=2030-12-25T16:14:21Z&sv=2022-11-02&sr=c&sig=Dm5p3uolBIMlq9FSZZk2sjyBvmTSO97BkWjL3fotlAA%3D',
          isFroiSroiEnabled: true,
        },
        leaselock: {
          blobSassUrl: 'https://leaselockprd.blob.core.windows.net',
          containerName: 'prd',
          token: 'sp=racwdlmep&st=2024-06-21T10:38:39Z&se=2030-12-21T19:38:39Z&sv=2022-11-02&sr=c&sig=vnCyMMr5FFQElikXUcJuWni%2FEf9VPtOmLSuv9PTYtUI%3D',
          isFroiSroiEnabled: true,
        },
        ingles: {
          blobSassUrl: 'https://inglesprd.blob.core.windows.net/',
          containerName: 'prd',
          token: 'sp=racwdlmeo&st=2024-09-21T12:34:46Z&se=2030-12-21T21:34:46Z&sv=2022-11-02&sr=c&sig=gtbJ50z7gCoTalXMsO%2BmLFzHXU8lpVrxRHuf9WSVlwk%3D',
          isFroiSroiEnabled: true,
        }
      },
    },
    qa: {
      AUTH_URL: 'https://qa.klearai.com',
      JOB_URL: 'https://qa-klearjobs-api.azurewebsites.net/api/',
      BASE_URL: 'https://qa-klearclaims-api.azurewebsites.net/api/',
      TOKEN_API_URL: 'https://qa-klearai-auth.azurewebsites.net/api/',
      DOC_URL: 'https://qa-klearai-util.azurewebsites.net/api/',
      EXTENDED_PERIOD: 120,
      TIMEOUT_PERIOD: 1800,
      REFRESH_TOKEN_TIME: 1800,
      CHECK_REFRESH_TOKEN_TIME: 900,
      PRODUCT_ID: '9',
      PARAMS_BY_CLIENT_MAP: {
        eco: {
          blobSassUrl: 'https://klearai.blob.core.windows.net',
          containerName: 'test',
          token:
            'sp=racwdlme&st=2022-11-23T15:14:35Z&se=2024-11-23T23:14:35Z&spr=https&sv=2021-06-08&sr=c&sig=yd7hKmhfxBvzM23mxEpNwAbIo8mdiVZVfwl4axmIIXU%3D',
          isFroiSroiEnabled: true,
        },
        adminsure: {
          blobSassUrl: 'https://klearai.blob.core.windows.net',
          containerName: 'test',
          token:
            'sp=racwdlme&st=2022-11-23T15:14:35Z&se=2024-11-23T23:14:35Z&spr=https&sv=2021-06-08&sr=c&sig=yd7hKmhfxBvzM23mxEpNwAbIo8mdiVZVfwl4axmIIXU%3D',
          isFroiSroiEnabled: true,
        },
        ics: {
          blobSassUrl: 'https://klearai.blob.core.windows.net',
          containerName: 'test',
          token:
            'sp=racwdlme&st=2022-11-23T15:14:35Z&se=2024-11-23T23:14:35Z&spr=https&sv=2021-06-08&sr=c&sig=yd7hKmhfxBvzM23mxEpNwAbIo8mdiVZVfwl4axmIIXU%3D',
          isFroiSroiEnabled: true,
        },
        solace: {
          blobSassUrl: 'https://klearai.blob.core.windows.net',
          containerName: 'test',
          token:
            'sp=racwdlme&st=2022-11-23T15:14:35Z&se=2024-11-23T23:14:35Z&spr=https&sv=2021-06-08&sr=c&sig=yd7hKmhfxBvzM23mxEpNwAbIo8mdiVZVfwl4axmIIXU%3D',
          isFroiSroiEnabled: true,
        },
      },
    },
    qa1: {
      AUTH_URL: 'https://qa1.klearai.com',
      JOB_URL: 'https://qa1-klearjobs-api.azurewebsites.net/api/',
      BASE_URL: 'https://qa1-klearclaims-api.azurewebsites.net/api/',
      TOKEN_API_URL: 'https://qa1-klearai-auth.azurewebsites.net/api/',
      DOC_URL: 'https://qa1-klearai-util.azurewebsites.net/api/',
      CLAIMS_URL: 'https://qa1-claims.klearai.com',
      UR_URL: 'https://qa1-ur.klearai.com',
      UM_URL: 'https://qa1-usermanagement.klearai.com',
      RMIS_URL: 'https://qa1-rmis.klearai.com',
      INTAKE_URL: 'https://qa1-intake.klearai.com',
      AUDIT_URL: 'https://qa1-audit.klearai.com',
      EXTENDED_PERIOD: 120,
      TIMEOUT_PERIOD: 1800,
      REFRESH_TOKEN_TIME: 1800,
      CHECK_REFRESH_TOKEN_TIME: 900,
      PRODUCT_ID: '9',
      LETTER_URL: 'https://api.office-integrator.com',
      PARAMS_BY_CLIENT_MAP: {
        adminsure: {
          blobSassUrl: 'https://klearai.blob.core.windows.net',
          containerName: 'test1',
          token:
            'sp=racwdlme&st=2023-08-03T02:20:52Z&se=2025-12-31T11:20:52Z&spr=https&sv=2022-11-02&sr=c&sig=Iyv7FfsSKLRoXCZky%2BSv0EaoI%2Bp0bOWst42YXqhFIW8%3D',
          isFroiSroiEnabled: true,
        },
        ics: {
          blobSassUrl: 'https://klearai.blob.core.windows.net',
          containerName: 'test1',
          token:
            'sp=racwdlme&st=2022-11-23T15:14:35Z&se=2024-11-23T23:14:35Z&spr=https&sv=2021-06-08&sr=c&sig=yd7hKmhfxBvzM23mxEpNwAbIo8mdiVZVfwl4axmIIXU%3D',
          isFroiSroiEnabled: true,
        },
        solace: {
          blobSassUrl: 'https://klearai.blob.core.windows.net',
          containerName: 'test1',
          token:
            'sp=racwdlme&st=2022-11-23T15:14:35Z&se=2024-11-23T23:14:35Z&spr=https&sv=2021-06-08&sr=c&sig=yd7hKmhfxBvzM23mxEpNwAbIo8mdiVZVfwl4axmIIXU%3D',
          isFroiSroiEnabled: true,
        },
      },
    },
    uat: {
      BASE_URL: 'https://uat-klearclaims-api.azurewebsites.net/api/',
      JOB_URL: 'https://uat-klearjobs-api.azurewebsites.net/api/',
      TOKEN_API_URL: 'https://uat-klearai-auth.azurewebsites.net/api/',
      AUTH_URL: 'https://uat-klearai.azurewebsites.net',
      DOC_URL: 'https://uat-klearai-util.azurewebsites.net/api/',
      EXTENDED_PERIOD: 120,
      TIMEOUT_PERIOD: 10800,
      REFRESH_TOKEN_TIME: 300,
      CHECK_REFRESH_TOKEN_TIME: 90,
      PRODUCT_ID: '9',
      PARAMS_BY_CLIENT_MAP: {
        adminsure: {
          blobSassUrl: 'https://adminsureklearaiuat.blob.core.windows.net',
          containerName: 'uat',
          token:
            '?sv=2021-06-08&ss=bfqt&srt=sco&sp=rwdlacupyx&se=2026-01-05T00:44:54Z&st=2023-01-04T16:44:54Z&spr=https&sig=kHSAaIduj2unuDGrWaoUvkMJPwRoyIQMGf51QN3S%2BDI%3D',
          isFroiSroiEnabled: true,
        },
        ics: {
          blobSassUrl: 'https://icsklearaiuat.blob.core.windows.net',
          containerName: 'uat',
          token:
            '?sv=2021-12-02&ss=b&srt=sco&sp=rwdlacyx&se=2026-01-01T02:24:40Z&st=2023-04-15T17:24:40Z&spr=https&sig=KKQXqpr4rWbsHBlEpEjmxRvaIMmf47xkx1S%2F0FmgRgY%3D',
          isFroiSroiEnabled: true,
        },
        solace: {
          blobSassUrl: 'https://solaceklearaiuat.blob.core.windows.net',
          containerName: 'uat',
          token:
            '?sp=racwdlme&st=2024-02-12T19:31:53Z&se=2026-01-01T03:31:53Z&spr=https&sv=2022-11-02&sr=c&sig=q1FZH2v%2FmEVqxW02x5qFlmkCPLMc%2BwQjv%2Fp10%2FKdw5o%3D',
          isFroiSroiEnabled: true,
        },
        pcm: {
          blobSassUrl: 'https://pcmklearaiuat.blob.core.windows.net',
          containerName: 'uat',
          token:
            '?sp=racwlme&st=2023-09-12T19:13:54Z&se=2025-01-01T04:13:54Z&spr=https&sv=2022-11-02&sr=c&sig=PFBM1S%2BLpXw6ahE%2BXdVze3OLMBHg5mB4gkGSXKhj2wQ%3D',
          isFroiSroiEnabled: true,
        },
        ingles: {
          blobSassUrl: 'https://inglesklearaiuat.blob.core.windows.net',
          containerName: 'uat',
          token:
            '?sp=racwlme&st=2023-09-12T19:12:37Z&se=2025-01-01T04:12:37Z&spr=https&sv=2022-11-02&sr=c&sig=ZIaIX4l0XvIyp32dDu9nYiHHoeixkSzQ1%2FoaYWwfLss%3D',
          isFroiSroiEnabled: true,
        },
        keenan: {
          blobSassUrl: 'https://keenanklearaiuat.blob.core.windows.net',
          containerName: 'uat',
          token:
            '?sp=r&st=2023-12-07T04:11:44Z&se=2025-12-31T12:11:44Z&spr=https&sv=2022-11-02&sr=c&sig=bTgBmFC67GPRstFjtUyAg5n%2BXYKpuHb34E0G9%2BYBkYI%3D',
          isFroiSroiEnabled: true,
        },
        sia: {
          blobSassUrl: 'https://siaklearaiuat.blob.core.windows.net',
          containerName: 'uat',
          token:
            '?sp=racwdlme&st=2024-02-12T18:55:22Z&se=2026-01-01T02:55:22Z&spr=https&sv=2022-11-02&sr=c&sig=8BUxsqmvccKOO0PAbYA%2FDrMQHFVlLT7JakyoUMRHX%2Fo%3D',
          isFroiSroiEnabled: true,
        },
        sierrarisk: {
          blobSassUrl: 'https://solaceklearaiuat.blob.core.windows.net',
          containerName: 'uat',
          token:
            '?sp=racwdlme&st=2024-02-12T19:31:53Z&se=2026-01-01T03:31:53Z&spr=https&sv=2022-11-02&sr=c&sig=q1FZH2v%2FmEVqxW02x5qFlmkCPLMc%2BwQjv%2Fp10%2FKdw5o%3D',
          isFroiSroiEnabled: true,
        },
        nextinsurance: {
          blobSassUrl: '',
          containerName: 'uat',
          token: '',
          isFroiSroiEnabled: true,
        },
        klearclaims: {
          blobSassUrl: 'https://klearclaimsuat.blob.core.windows.net',
          containerName: 'uat',
          token:
            '?sp=racwle&st=2024-03-06T03:27:08Z&se=2025-12-31T11:27:08Z&spr=https&sv=2022-11-02&sr=c&sig=ZZaP%2B7iuo9y%2FxnmLqQeDDa%2B9t7DRP0YjhFTvIkRDjh4%3D',
          isFroiSroiEnabled: true,
        },
        gas: {
          blobSassUrl: 'https://gasklearaiuat.blob.core.windows.net',
          containerName: 'uat',
          token:
            '?sp=racwdlmep&st=2024-06-17T12:20:50Z&se=2030-12-01T21:20:50Z&sv=2022-11-02&sr=c&sig=cvT51G%2FS5opg0k2oWUCDT%2FQeqWJXhVp7kjUrVsgh9%2BA%3D',
          isFroiSroiEnabled: true,
        },
        cobbcounty: {
          blobSassUrl: 'https://cobbcountyuat.blob.core.windows.net',
          containerName: 'uat',
          token:
            '?sp=racwdlmep&st=2024-06-17T15:12:12Z&se=2024-06-17T23:12:12Z&sv=2022-11-02&sr=c&sig=LF%2F3xO5wsB9d4FezdgO%2Bb89MZjHkNBa2%2Fkeui9Mv6wk%3D',
          isFroiSroiEnabled: true,
        },
        gardengrove: {
          blobSassUrl: 'https://gardengroveuat.blob.core.windows.net',
          containerName: 'uat',
          token:
            '?sp=racwdlmep&st=2024-06-17T15:08:41Z&se=2024-06-17T23:08:41Z&sv=2022-11-02&sr=c&sig=A9EA1PUwozwKQzSRrFWvPmAraziflsT0qSYy54DEDYM%3D',
          isFroiSroiEnabled: true,
        },
        leaselock: {
          blobSassUrl: 'https://leaselockklearaiuat.blob.core.windows.net',
          containerName: 'uat',
          token:
            '?sp=racwdlm&st=2024-06-20T14:55:33Z&se=2025-12-31T23:55:33Z&spr=https&sv=2022-11-02&sr=c&sig=rQcmoCGDW8%2FB3nkblNEu5SZMGj6KaQaJoHGMr%2Bykx0Q%3D',
          isFroiSroiEnabled: true,
        },
        stockton: {
          blobSassUrl: 'https://stocktonuat.blob.core.windows.net',
          containerName: 'uat',
          token:
            'sp=racwdlmep&st=2024-07-03T10:01:34Z&se=2030-12-03T19:01:34Z&sv=2022-11-02&sr=c&sig=CtDp1suJjwA1TJLetDKplTvWPUBlxT3ZBwEsHLE3yT0%3D',
          isFroiSroiEnabled: true,
        },
        convkeenan: {
          blobSassUrl: 'https://convkeenanklearaiuat.blob.core.windows.net',
          containerName: 'uat',
          token:
            '?sp=racwdlm&st=2024-06-25T14:50:25Z&se=2025-12-31T23:50:25Z&spr=https&sv=2022-11-02&sr=c&sig=UK2BhRzPK3aAMFWIZVES48Nu%2F6SYoVBgRUyecQ7YFgo%3D',
          isFroiSroiEnabled: true,
        },
        convingles: {
          blobSassUrl: 'https://inglesconvuat.blob.core.windows.net',
          containerName: 'convuat',
          token:
            '?sp=racwdlmeo&st=2024-09-05T09:44:10Z&se=2030-12-05T18:44:10Z&sv=2022-11-02&sr=c&sig=jUvZeMw2IHg2HZIQh%2FEBN%2Fu7BjxxzsbCb9QCLnzCP68%3D',
          isFroiSroiEnabled: true,
        },
        lacounty: {
          blobSassUrl: 'https://lacountyuat.blob.core.windows.net',
          containerName: 'uat',
          token:
            '?sp=racwdlmeo&st=2024-09-10T13:58:30Z&se=2030-12-10T22:58:30Z&sv=2022-11-02&sr=c&sig=cU4v6MbZrspEijAoLNHJ4ZZPQHfPhJVS%2FZEOawprvR8%3D',
          isFroiSroiEnabled: true,
        },
        is: {
          blobSassUrl: 'https://isklearaiuat.blob.core.windows.net',
          containerName: 'uat',
          token:
            '?sp=racwdlmeo&st=2024-09-10T14:20:10Z&se=2030-12-10T23:20:10Z&sv=2022-11-02&sr=c&sig=plqzxh03uHWcT%2BSBOuDHIBNpJcs5eEPbhByOpVpEO5M%3D',
          isFroiSroiEnabled: true,
        },
        nclm: {
          blobSassUrl: 'https://nclmuat.blob.core.windows.net',
          containerName: 'uat',
          token:
            '?sp=racwdlmeo&st=2024-09-11T13:16:33Z&se=2030-12-11T22:16:33Z&sv=2022-11-02&sr=c&sig=UYNNFy1HS8LMGmuoX2R5YkEtoR1%2FwSlv%2F%2FdZzwLWTXA%3D',
          isFroiSroiEnabled: true,
        }
      },
    },
    sb: {
      BASE_URL: 'https://sb-klearclaims-api.azurewebsites.net/api/',
      JOB_URL: 'https://sb-klearjobs-api.azurewebsites.net/api/',
      TOKEN_API_URL: 'https://sb-klearai-auth.azurewebsites.net/api/',
      AUTH_URL: 'https://sb-klearai.azurewebsites.net',
      DOC_URL: 'https://sb-klearai-util.azurewebsites.net/api/',
      EXTENDED_PERIOD: 120,
      TIMEOUT_PERIOD: 10800,
      REFRESH_TOKEN_TIME: 300,
      CHECK_REFRESH_TOKEN_TIME: 90,
      PRODUCT_ID: '9',
      PARAMS_BY_CLIENT_MAP: {
        adminsure: {
          blobSassUrl: 'https://adminsureklearaisb.blob.core.windows.net',
          containerName: 'sb',
          token: '',
          isFroiSroiEnabled: true,
        },
        ics: {
          blobSassUrl: 'https://icsklearaisb.blob.core.windows.net',
          containerName: 'sb',
          token: '',
          isFroiSroiEnabled: true,
        },
        solace: {
          blobSassUrl: '',
          containerName: 'sb',
          token: '',
          isFroiSroiEnabled: true,
        },
        keenan: {
          blobSassUrl: 'https://keenanklearaisandbox.blob.core.windows.net',
          containerName: 'sandbox',
          token:
            '?sp=racwdlme&st=2023-06-19T17:38:09Z&se=2026-01-01T04:59:09Z&spr=https&sv=2022-11-02&sr=c&sig=hVTw%2BoKAQduAWB826Io%2BUS4nbUOPN7bHQlOwc2fCfcs%3D',
          isFroiSroiEnabled: true,
        },
      },
    },
    sit: {
      BASE_URL: 'https://sb-klearclaims-api.azurewebsites.net/api/',
      JOB_URL: 'https://sb-klearjobs-api.azurewebsites.net/api/',
      TOKEN_API_URL: 'https://sb-klearai-auth.azurewebsites.net/api/',
      AUTH_URL: 'https://sit-klearai.azurewebsites.net',
      DOC_URL: 'https://sb-klearai-util.azurewebsites.net/api/',
      EXTENDED_PERIOD: 120,
      TIMEOUT_PERIOD: 10800,
      REFRESH_TOKEN_TIME: 300,
      CHECK_REFRESH_TOKEN_TIME: 90,
      PRODUCT_ID: '9',
      PARAMS_BY_CLIENT_MAP: {
        adminsure: {
          blobSassUrl: 'https://adminsureklearaisb.blob.core.windows.net',
          containerName: 'sb',
          token: '',
          isFroiSroiEnabled: true,
        },
        ics: {
          blobSassUrl: 'https://icsklearaisb.blob.core.windows.net',
          containerName: 'sb',
          token: '',
          isFroiSroiEnabled: true,
        },
        solace: {
          blobSassUrl: '',
          containerName: 'sb',
          token: '',
          isFroiSroiEnabled: true,
        },
        keenan: {
          blobSassUrl: 'https://keenanklearaisandbox.blob.core.windows.net',
          containerName: 'sandbox',
          token:
            '?sp=racwdlme&st=2023-06-19T17:38:09Z&se=2026-01-01T04:59:09Z&spr=https&sv=2022-11-02&sr=c&sig=hVTw%2BoKAQduAWB826Io%2BUS4nbUOPN7bHQlOwc2fCfcs%3D',
          isFroiSroiEnabled: true,
        },
      },
    },
    stg: {
      BASE_URL: 'https://stg-klearclaims-api.azurewebsites.net/api/',
      JOB_URL: 'https://stg-klearjobs-api.azurewebsites.net/api/',
      TOKEN_API_URL: 'https://stg-klearai-auth.azurewebsites.net/api/',
      AUTH_URL: 'https://stg-klearai.azurewebsites.net',
      DOC_URL: 'https://stg-klearai-util.azurewebsites.net/api/',
      EXTENDED_PERIOD: 120,
      TIMEOUT_PERIOD: 10800,
      REFRESH_TOKEN_TIME: 300,
      CHECK_REFRESH_TOKEN_TIME: 90,
      PRODUCT_ID: '9',
      PARAMS_BY_CLIENT_MAP: {
        adminsure: {
          blobSassUrl: 'https://adminsureklearaistg.blob.core.windows.net',
          containerName: 'stg',
          token:
            '?sp=racwlm&st=2023-07-26T16:43:15Z&se=2024-07-27T00:43:15Z&spr=https&sv=2022-11-02&sr=c&sig=V4xhtoEjBzh2l0T2HvPWTGa5ivRTVzyXBP3DPEPIayE%3D',
          isFroiSroiEnabled: true,
        },
        ics: {
          blobSassUrl: 'https://icsklearaistg.blob.core.windows.net',
          containerName: 'stg',
          token:
            '?sp=racwdlmeop&st=2023-07-26T16:42:06Z&se=2024-07-27T00:42:06Z&spr=https&sv=2022-11-02&sr=c&sig=p9Jy5OoKQ3Zg9WtzgfSL%2BxqAD7lZ%2ByhnIjGuHJs2Ol8%3D',
          isFroiSroiEnabled: true,
        },
        solace: {
          blobSassUrl: '',
          containerName: 'stg',
          token: '',
          isFroiSroiEnabled: true,
        },
        keenan: {
          blobSassUrl: '',
          containerName: 'stg',
          token: '',
          isFroiSroiEnabled: true,
        }
      },
    },
    preprod: {
      JOB_URL: 'https://preprod-klearjobs-api.azurewebsites.net/api/',
      CLAIMS_URL: 'https://preprod-claims.klearai.com',
      UR_URL: 'https://preprod-ur.klearai.com',
      UM_URL: 'https://preprod-usermanagement.klearai.com',
      RMIS_URL: 'https://preprod-rmis.klearai.com',
      INTAKE_URL: 'https://preprod-intake.klearai.com',
      AUDIT_URL: 'https://preprod-audit.klearai.com',
      AUTH_URL: 'https://preprod.klearai.com',
      BASE_URL: 'https://preprod-klearclaims-api.azurewebsites.net/api/',
      TOKEN_API_URL: 'https://preprod-klearai-auth.azurewebsites.net/api/',
      DOC_URL: 'https://preprod-klearai-util.azurewebsites.net/api/',
      EXTENDED_PERIOD: 120,
      TIMEOUT_PERIOD: 6000,
      REFRESH_TOKEN_TIME: 300,
      CHECK_REFRESH_TOKEN_TIME: 90,
      PRODUCT_ID: '1',
      LETTER_URL: 'https://api.office-integrator.com',
      PARAMS_BY_CLIENT_MAP: {
        ics: {
          blobSassUrl: 'https://icspreprod.blob.core.windows.net',
          containerName: 'uat',
          token:
            '?sp=racwdlmeo&st=2024-07-12T06:18:53Z&se=2030-12-12T15:18:53Z&sv=2022-11-02&sr=c&sig=9AX99MFRdpnnKIIJffw2ytZN7QDtdECjZ6sZ8KWQ87w%3D',
          isFroiSroiEnabled: true,
        }
      },
    }
  };
}
